enum Events {
  ActiveTrade = 'finance|active-trade',
  CkPromoModalOpen = 'vdp|ck-promo-modal|open',
  EstimatedAmountFinanced = 'finance|estimated-amount-financed',
  EvTaxCreditModalOpen = 'vdp|ev-tax-credit-modal|open',
  Geolocation = 'vdp|geolocation',
  GetStarted = 'vdp|get-started',
  HeaderAccountModalClose = 'header|account-modal|close',
  HeaderAccountModalOpen = 'header|account-modal|open',
  FinanceIsError = 'finance|is-error',
  FinanceIsLoading = 'finance|is-loading',
  IsTradeInApplied = 'finance|is-trade-in-applied',
  UserFinancing = 'finance|user-financing',
  UserProfile = 'vdp|user-profile'
}

export default Events;
